import { AxiosResponse } from "axios"
import { useMutation } from "react-query"

import contentService from "api/contentService"
import { LANGS } from "types/shared"
import { IUpdateAdminKeywordsBodyParams } from "types/content"
import { useUI } from "providers/UIProvider"
import { RESPONSE_MODAL_VARIANTS } from "components/shared/modals/ResponseModal/ResponseModalTypes"
import { toast } from "react-toastify"

interface IUseUpdateAdmintKeywords {
  lang: LANGS,
  data: IUpdateAdminKeywordsBodyParams
} 

const useUpdateAdminKeywords = () => {
  const { toggleModal } = useUI()

  return useMutation(async ({ lang, data }: IUseUpdateAdmintKeywords) => {
    const res: AxiosResponse<any> = await contentService.updateAdminKeywords(lang, data)

    return res.data
  }, {
    onSuccess: () => {
      toggleModal("responseModal", true, { variant: RESPONSE_MODAL_VARIANTS.SUCCESS })
      setTimeout(()=>toggleModal("responseModal", false), 3000)
    },
    onError: () => {
      toast.error("Internal Server Error")
    }
  })
}

export default useUpdateAdminKeywords